import { render, staticRenderFns } from "./LandingVideoText.vue?vue&type=template&id=49435dda&name=landing-video-text&"
import script from "./LandingVideoText.vue?vue&type=script&lang=js&"
export * from "./LandingVideoText.vue?vue&type=script&lang=js&"
import style0 from "./LandingVideoText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports